import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
      
        this.input = this.$('input')[0];
    }

    init() {
      this.input.addEventListener("keyup", this.onChange.bind(this));
    }

    onChange(event) {
      if(event.target.value !== "") {
        this.input.classList.add("is-filled");
      } else {
        this.input.classList.remove("is-filled");
      }
    }
}
